module.exports = __webpack_public_path__ + "img/pic2.7fd60976.png";